"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalErrors = void 0;
var _react = _interopRequireDefault(require("react"));
var _Alert = _interopRequireDefault(require("@mui/material/Alert"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ModalErrors = exports.ModalErrors = function ModalErrors(_ref) {
  var responseError = _ref.responseError;
  if (!responseError) {
    return;
  }
  var errors = responseError.errors,
    detail = responseError.detail;
  var message;
  if (errors && errors.length === 1) {
    message = /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.titleCase)(errors[0].detail));
  } else {
    message = /*#__PURE__*/_react.default.createElement("ul", null, errors.map(function (el, i) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i
      }, (0, _utils.titleCase)(el.detail));
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "error"
  }, detail, message);
};